import OrdersTableModule from "./OrdersTableModule";

export default OrdersTableModule;